
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_42631","data-name":"Group 42631","xmlns":"http://www.w3.org/2000/svg","width":"24.808","height":"22.518"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_29660","data-name":"Path 29660","d":"M2.226 7.15L12.4 1.16l10.183 5.99L12.4 13.141zM12.4 0L.254 7.15 12.4 14.3l12.155-7.15z"}}),_c('g',{attrs:{"id":"Group_42630","data-name":"Group 42630"}},[_c('g',{attrs:{"id":"Group_42632","data-name":"Group 42632","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_29661","data-name":"Path 29661","d":"M.254 10.969l12.15 7.15 12.151-7.15"}}),_c('path',{attrs:{"id":"Path_29662","data-name":"Path 29662","d":"M.254 14.787l12.15 7.15 12.151-7.15"}})])])])
          )
        }
      }
    